import type { ReactNode } from 'react';

interface CtaSectionProps {
  title: string;
  cta: ReactNode;
  label?: string;
}

function CtaSection({ cta, title, label }: CtaSectionProps) {
  return (
    <section className='text-white bg-[url(/cta-banner-background.svg)] bg-no-repeat bg-cover'>
      <div className='px-4 mx-auto md:container flex flex-col items-center justify-center py-[42px]'>
        {label && <p>{label}</p>}
        <h2
          className='my-5 text-center max-w-[1000px] text-[2rem] leading-[2.25rem] md:text-[2.5rem] md:leading-[2.75rem]'
          dangerouslySetInnerHTML={{ __html: title }}
        />

        {cta}
      </div>
    </section>
  );
}

export default CtaSection;
